interface Props {
  className?: string
}

export const SortIcon: React.VFC<Props> = ({ className = '' }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 10 18"
    fill="#161015"
  >
    <path d="M5,2.8L8.2,6l1.4-1.4L5,0L0.4,4.6L1.8,6L5,2.8z M5,15.2L1.8,12l-1.4,1.4L5,18l4.6-4.6L8.2,12L5,15.2z" />
  </svg>
)
